import USER_ROLES from "../../constants/userRoles.constants";

const MANAGE_SKILLS_STATES = {
    NONE: "",
    PEDAGOGICAL_APPROACH: "PEDAGOGICAL_APPROACH",
    LEARNING_ENGAGEMENT: {
        MINI: "LEARNING_ENGAGEMENT_MINI",
        FULL: "LEARNING_ENGAGEMENT_FULL",
    },
    GDPR: "GDPR",
};

class ManageSkillsController {
    constructor(
        $state,
        $mdDialog,
        $mdToast,
        $q,
        manageSkillsService,
        subjectAreaService,
        learningAreaService,
        curriculumService,
        gradeService,
        userService
    ) {
        let self = this;
        self.MANAGE_SKILLS_STATES = MANAGE_SKILLS_STATES;
        self.state = MANAGE_SKILLS_STATES.NONE;
        self.selectedCurriculum = null;
        self.selectedLearningArea = null;
        self.selectedArea = null;

        subjectAreaService
            .list()
            .then((data) => {
                self.allAreas = data;
            })
            .catch((e) => console.log("ERROR", e));

        this.loadCurriculums = () => {
            return curriculumService.list().then((data) => {
                self.curriculums = data;
            });
        };

        this.saveCurriculum = (curriculum) => {
            curriculumService.save(curriculum).then((data) => {
                self.selectedCurriculum.name = data.name;
                self.loadCurriculums();
            });
        };

        this.loadLearningAreas = () => {
            return learningAreaService
                .list()
                .then((data) => (self.learningAreas = data));
        };

        this.createGrade = (grade) => {
            return (
                grade.curriculum
                    ? gradeService.createSubjectGrade(grade)
                    : gradeService.createLearningGrade(grade)
            ).then((data) => {
                self.loadCurriculums().then(() => {
                    if (grade.name) {
                        if (self.selectedArea && grade.curriculum) {
                            self.selectedArea.grades.push(data);
                        } else if (self.selectedLearningArea) {
                            self.selectedLearningArea.grades.push(data);
                        }
                        self.selectedGrade = data;
                    }
                });
            });
        };

        this.saveGrade = (grade) => {
            return (
                grade.curriculum
                    ? gradeService.saveSubjectGrade(grade)
                    : gradeService.saveLearningGrade(grade)
            ).then((data) => {
                grade = data;
                if (self.selectedGrade.id === data.id && data.name) {
                    self.selectedGrade = data;
                }
                if (self.selectedArea) {
                    self.selectedArea.grades.some((oldGrade) => {
                        if (data.id === oldGrade.id) {
                            oldGrade.name = data.name;
                            return true;
                        }
                    });
                } else if (self.selectedLearningArea) {
                    self.selectedLearningArea.grades.some((oldGrade) => {
                        if (data.id === oldGrade.id) {
                            oldGrade.name = data.name;
                            return true;
                        }
                    });
                }
            });
        };

        this.createArea = (area) => {
            return subjectAreaService.create(area).then(() => {
                manageSkillsService
                    .getAllAreasData()
                    .then((res) => {
                        self.subjectAreas = res;
                    })
                    .catch((e) => console.log("ERROR", e));
            });
        };

        this.saveArea = (area) => {
            return subjectAreaService.save(area).then(() => {
                curriculumService
                    .getById(self.selectedCurriculum.id)
                    .then((curriculum) =>
                        self.curriculums.some((oldCurriculum) => {
                            if (oldCurriculum.id === curriculum.id) {
                                oldCurriculum.name = curriculum.name;
                                return true;
                            }
                        })
                    );
            });
        };

        this.showUsedEvaluations = (skill) => {
            manageSkillsService.getSkillsEvaluation(skill).then((res) =>
                $mdDialog.show({
                    multiple: true,
                    clickOutsideToClose: true,
                    template: require("./skillsEvaluations.html"),
                    controller: ($scope, $mdDialog) => {
                        $scope.closeDialog = () => $mdDialog.hide();
                        $scope.skill = skill;
                        $scope.evaluations = res;
                    },
                })
            );
        };

        this.deleteArea = () => {
            $mdDialog
                .show(
                    $mdDialog.confirm({
                        title: "Warning",
                        textContent: `Are you sure you want to delete "${self.selectedArea.name}" subject area? `,
                        ok: "OK",
                        cancel: "Cancel",
                        multiple: true,
                    })
                )
                .then(
                    () => {
                        subjectAreaService
                            .delete(self.selectedArea.id)
                            .then(() => {
                                if (self.selectedCurriculum) {
                                    self.selectedCurriculum.areas.splice(
                                        self.selectedCurriculum.areas.findIndex(
                                            (area) =>
                                                self.selectedArea.id === area.id
                                        ),
                                        1
                                    );
                                }
                                self.selectedArea = null;
                                self.loadCurriculums();
                            })
                            .catch(() => {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(
                                            "The area is used in at least one evaluation"
                                        )
                                        .position("top center")
                                        .action("Hide")
                                        .highlightAction(true)
                                        .hideDelay(4000)
                                        .toastClass("error-toast")
                                );
                            });
                    },
                    function () {
                        return false;
                    }
                );
        };

        this.saveSubcategory = (subcategory, subjectArea) => {
            return manageSkillsService
                .saveAreaSubcategory(subcategory, subjectArea)
                .then((res) => {
                    subjectArea.subcategories[
                        subjectArea.subcategories.findIndex(
                            (e) => e.name === res.name
                        )
                    ] = res.data;
                });
        };

        this.deleteGrade = () => {
            $mdDialog
                .show(
                    $mdDialog.confirm({
                        title: "Warning",
                        textContent: `Are you sure you want to delete "${self.selectedGrade.name}" category? `,
                        ok: "OK",
                        cancel: "Cancel",
                        multiple: true,
                    })
                )
                .then(
                    () => {
                        (self.selectedArea
                            ? gradeService.deleteSubjectGrade(
                                  self.selectedGrade.id
                              )
                            : gradeService.deleteLearningGrade(
                                  self.selectedGrade.id
                              )
                        )
                            .then(() => {
                                if (self.selectedArea) {
                                    self.selectedArea.grades.splice(
                                        self.selectedArea.grades.findIndex(
                                            (grade) =>
                                                self.selectedGrade.id ===
                                                grade.id
                                        ),
                                        1
                                    );
                                } else if (self.selectedLearningArea) {
                                    self.selectedLearningArea.grades.splice(
                                        self.selectedLearningArea.grades.findIndex(
                                            (grade) =>
                                                self.selectedGrade.id ===
                                                grade.id
                                        ),
                                        1
                                    );
                                }
                                self.selectedGrade = null;
                                self.loadCurriculums();
                            })
                            .catch(() => {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(
                                            "The grade has skills or is used by evaluation."
                                        )
                                        .position("top center")
                                        .action("Hide")
                                        .highlightAction(true)
                                        .hideDelay(4000)
                                        .toastClass("error-toast")
                                );
                            });
                    },
                    function () {
                        return false;
                    }
                );
        };

        this.getSubjectAreaSkills = (subjectArea) => {
            manageSkillsService
                .getAreaSkills(subjectArea)
                .then((res) => {
                    self.currSubjectArea = res;
                })
                .catch((e) => console.log("ERROR", e));
        };

        this.deleteSkill = (grade, skill) => {
            $mdDialog
                .show(
                    $mdDialog.confirm({
                        title: "Warning",
                        textContent: `Are you sure you want to delete "${skill.name}" skill? `,
                        ok: "OK",
                        cancel: "Cancel",
                        multiple: true,
                    })
                )
                .then(
                    () => {
                        manageSkillsService
                            .deleteSkill(skill)
                            .then(() => {
                                grade.skills = grade.skills.filter(
                                    (e) => e.id !== skill.id
                                );
                            })
                            .catch(() => {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(
                                            "The skill is used by an evaluation."
                                        )
                                        .position("top center")
                                        .action("Hide")
                                        .highlightAction(true)
                                        .hideDelay(4000)
                                        .toastClass("error-toast")
                                );
                            });
                    },
                    function () {
                        return false;
                    }
                );
        };

        this.clearAllSelections = () => {
            self.selectedLearningArea = null;
            self.selectedGrade = null;
            self.selectedCurriculum = null;
            self.selectedArea = null;
        };

        this.selectCurriculum = (curriculum) => {
            self.state = MANAGE_SKILLS_STATES.NONE;
            this.clearAllSelections();
            self.selectedCurriculum = curriculum;
            self.selectedArea =
                curriculum.areas.length > 0 ? curriculum.areas[0] : null;
        };

        this.selectLearningArea = (learningArea) => {
            self.state = MANAGE_SKILLS_STATES.NONE;
            this.clearAllSelections();
            self.selectedLearningArea = learningArea;
            self.selectedGrade =
                learningArea.grades.length > 0 ? learningArea.grades[0] : null;
        };

        this.selectGrade = (grade) => {
            self.state = MANAGE_SKILLS_STATES.NONE;
            self.selectedGrade = grade;
        };

        this.onSelectArea = () => {
            self.selectedGrade = null;
        };

        this.showNewGradePrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "easy-prompt.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    locals: {
                        text: "Enter new name of new grade",
                    },
                    controller: function DialogController(
                        $scope,
                        $mdDialog,
                        text
                    ) {
                        $scope.name = "";
                        $scope.title = text;

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };
                        $scope.save = function () {
                            $mdDialog.hide($scope.name);
                        };
                    },
                })
                .then(
                    function (result) {
                        let toSave = {
                            name: result,
                            area: self.selectedLearningArea
                                ? self.selectedLearningArea.id
                                : self.selectedArea.id,
                            curriculum: self.selectedCurriculum
                                ? self.selectedCurriculum.id
                                : null,
                        };
                        self.createGrade(toSave);
                    },
                    function () {}
                );
        };

        this.showEditGradePrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "easy-prompt.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    locals: {
                        text: "Enter new name of the grade",
                        name: self.selectedGrade.name,
                    },
                    controller: function DialogController(
                        $scope,
                        $mdDialog,
                        text,
                        name
                    ) {
                        $scope.name = name;
                        $scope.title = text;

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };
                        $scope.save = function () {
                            $mdDialog.hide($scope.name);
                        };
                    },
                })
                .then(
                    (result) => {
                        const toSave = { ...self.selectedGrade };
                        toSave.name = result;
                        if (self.selectedCurriculum) {
                            toSave.curriculum = self.selectedCurriculum.id;
                            toSave.area = self.selectedArea.id;
                        } else if (self.selectedLearningArea) {
                            toSave.area = self.selectedLearningArea.id;
                        }
                        self.saveGrade(toSave);
                    },
                    function () {}
                );
        };

        this.showEditCurriculumPrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "easy-prompt.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    locals: {
                        text: "Enter new name of the curriculum",
                        name: self.selectedCurriculum.name,
                    },
                    controller: function DialogController(
                        $scope,
                        $mdDialog,
                        text,
                        name
                    ) {
                        $scope.name = name;
                        $scope.title = text;

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };
                        $scope.save = function () {
                            $mdDialog.hide($scope.name);
                        };
                    },
                })
                .then(
                    (result) => {
                        const toSave = { ...self.selectedCurriculum };
                        toSave.name = result;
                        self.saveCurriculum(toSave);
                    },
                    function () {}
                );
        };

        this.deleteCurriculum = (curriculum) => {
            $mdDialog
                .show(
                    $mdDialog.confirm({
                        title: "Warning",
                        textContent: `Are you sure you want to delete "${curriculum.name}" curriculum? `,
                        ok: "OK",
                        cancel: "Cancel",
                        multiple: true,
                    })
                )
                .then(
                    function () {
                        curriculumService
                            .delete(curriculum.id)
                            .then(() => {
                                self.selectedCurriculum = null;
                                self.loadCurriculums();
                            })
                            .catch(() => {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(
                                            "The curriculum has some grades or is used by an evaluation."
                                        )
                                        .position("top center")
                                        .action("Hide")
                                        .highlightAction(true)
                                        .hideDelay(4000)
                                        .toastClass("error-toast")
                                );
                            });
                    },
                    function () {
                        return false;
                    }
                );
        };

        this.addNewSkill = (grade, skill) => {
            skill.edited = false;
            manageSkillsService.saveSkill(skill, grade).then((data) => {
                const found = grade.skills.some((oldSkills) => {
                    if (oldSkills.name === data.name) {
                        oldSkills.id = data.id;
                        return true;
                    }
                });
                if (!found) {
                    self.selectedGrade.skills.push(data);
                }
            });
        };

        this.showNewAreaPrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "newSimpleAreaDialog.tmpl.html",
                    // templateUrl: self.selectedArea ? 'newSimpleAreaDialog.tmpl.html' : 'newAreaDialog.tmpl.html',
                    parent: angular.element(document.body),
                    multiple: true,
                    controller: function DialogController(
                        $scope,
                        $mdDialog,
                        $q
                    ) {
                        $scope.search = (term) => {
                            if (term.replace(/[#.\\\/]/gi, "").length > 2) {
                                return $q((resolve, reject) => {
                                    resolve(
                                        self.allAreas.filter((area) =>
                                            area.name.includes(term)
                                        )
                                    );
                                });
                            }
                            return [];
                        };

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };

                        $scope.save = function (grade, area) {
                            if (area) {
                                grade.areaName = area;
                            }
                            $mdDialog.hide(grade);
                        };
                    },
                })
                .then(
                    function (result) {
                        let toSave = {
                            name: result.name,
                        };
                        if (self.selectedCurriculum) {
                            toSave.curriculum = self.selectedCurriculum.id;

                            if (result.areaName) {
                                const foundArea = self.allAreas.find((area) => {
                                    return area.name === result.areaName;
                                });

                                if (foundArea) {
                                    toSave.area = foundArea.id;
                                    self.createGrade(toSave);
                                } else {
                                    subjectAreaService
                                        .create({ name: result.areaName })
                                        .then((area) => {
                                            if (self.selectedCurriculum) {
                                                self.selectedCurriculum.areas.push(
                                                    area
                                                );
                                            }
                                            toSave.area = area.id;
                                            self.createGrade(toSave);
                                        });
                                }
                            } else {
                                subjectAreaService
                                    .create({ name: toSave.name })
                                    .then((area) => {
                                        if (self.selectedCurriculum) {
                                            self.selectedCurriculum.areas.push(
                                                area
                                            );
                                        }
                                        const grade = {
                                            name: "",
                                            area: area.id,
                                            curriculum: self.selectedCurriculum
                                                ? self.selectedCurriculum.id
                                                : null,
                                        };
                                        self.createGrade(grade);
                                    });
                            }
                        } else {
                            result.area = self.selectedLearningArea.id;
                            self.createGrade(toSave);
                        }
                    },
                    function () {}
                );
        };

        this.showEditAreaPrompt = (area) => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "newSimpleAreaDialog.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    controller: function DialogController($scope, $mdDialog) {
                        $scope.area = {};
                        $scope.area.name = area.name;

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };
                        $scope.save = function (result) {
                            $mdDialog.hide(result);
                        };
                    },
                })
                .then(
                    function (result) {
                        area.name = result.name;
                        self.saveArea(area);
                    },
                    function () {}
                );
        };

        this.addNewCurriculumPrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "newCurriculum.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    controller: function DialogController($scope, $mdDialog) {
                        $scope.curriculum = {
                            name: "",
                        };

                        $scope.closeDialog = function () {
                            $mdDialog.cancel();
                        };
                        $scope.save = function (curriculum) {
                            $mdDialog.hide(curriculum);
                        };
                    },
                })
                .then(
                    function (curriculum) {
                        curriculumService
                            .create(curriculum)
                            .then((response) => {
                                self.loadCurriculums();
                            });
                    },
                    function () {}
                );
        };

        this.enableSkillsMode = () => {
            self.state = MANAGE_SKILLS_STATES.NONE;
        };

        this.enableEngagementMode = () => {
            self.clearAllSelections();
            self.state = self.MANAGE_SKILLS_STATES.LEARNING_ENGAGEMENT.MINI;
        };

        this.enablePedagogicalMode = () => {
            self.clearAllSelections();
            self.state = self.MANAGE_SKILLS_STATES.PEDAGOGICAL_APPROACH;
        };

        this.enableGdprMode = () => {
            self.clearAllSelections();
            self.state = self.MANAGE_SKILLS_STATES.GDPR;
        };

        if (userService.isInRole(USER_ROLES.ROLE_ADMIN)) {
            this.loadCurriculums();
            this.loadLearningAreas();
        } else {
            $state.go("home");
        }
    }
}

ManageSkillsController.$inject = [
    "$state",
    "$mdDialog",
    "$mdToast",
    "$q",
    "manageSkillsService",
    "subjectAreaService",
    "learningAreaService",
    "curriculumService",
    "gradeService",
    "UserService",
];

export default ManageSkillsController;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/ManageSkillsController.js